import { StylistState } from '@drycut/graphql';
import { Heading, Stack } from '@drycut/ui-components';

import { CustomerBox } from '../CustomerBox';
import { CuttingTime } from '../CuttingTime';
import { ServiceStartReminder } from '../ServiceStartReminder';
import { StylistActions } from '../StylistActions';
import { useStylistCardContext } from '../StylistCardContext';
import Avatar from './Avatar';

export function StylistCard(): React.ReactNode {
  const { stylist, actionsOpen, toggleActions } = useStylistCardContext();

  if (!stylist) return null;

  const customer = stylist?.currentServiceExecution?.customer;
  const booking = stylist?.currentServiceExecution?.booking;

  return (
    <Stack className="relative w-64 shadow">
      <Stack
        className="cursor-pointer bg-zinc-50 hover:bg-zinc-100 active:bg-primary-600/10 p-4"
        onClick={toggleActions}
      >
        <Stack className="relative items-center gap-4">
          <Heading variant="h4" className="opacity-60">
            {stylist.name}
          </Heading>

          <Avatar stylist={stylist} />

          {booking && customer && <CustomerBox booking={booking} customer={customer} />}

          <CuttingTime stylist={stylist} />

          <StylistActions open={actionsOpen} stylist={stylist} />
        </Stack>
      </Stack>

      {stylist.state === StylistState.WaitingCustomer && <ServiceStartReminder stylist={stylist} />}
    </Stack>
  );
}
